import { render } from "./TagsView.vue?vue&type=template&id=4bebdb09&scoped=true"
import script from "./TagsView.vue?vue&type=script&lang=js"
export * from "./TagsView.vue?vue&type=script&lang=js"

import "./TagsView.vue?vue&type=style&index=0&id=4bebdb09&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/build_logistics-fe-ntp-hz_cb461e37a40e4d4db048201803700c7a/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bebdb09"]])

export default __exports__